import { render } from "./Kits.vue?vue&type=template&id=00013ddc"
import script from "./Kits.vue?vue&type=script&lang=js"
export * from "./Kits.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__